import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessBoardsMoveBoardPostRequest } from '../types/JobChangeProcessBoard';
import parseBoardResponse from './parseBoardResponse';

export default function usePostJobChangeProcessBoardsMoveBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      targetBoardId,
      order_number,
    }: JobChangeProcessBoardsMoveBoardPostRequest) => {
      const response = await fetch(
        `/agent/api/job_change_process_boards/${targetBoardId}/move_board`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({
            order_number,
          }),
        }
      );
      return parseBoardResponse(response, 'ボードの並べ替えに失敗しました');
    },
  });
}
